import { css } from "@emotion/css";

export const DivStyle = css`
  display: grid;
  align: center;
  justify-content: center;
`;
